import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import classes from "./AddPost.module.css";
import Compressor from "compressorjs";
import { getStorage } from "firebase/storage";
import { firebaseApp } from "../../config/firebase";
import * as service from "../../pages/Admin/services/fileService";

const storageRef = getStorage(firebaseApp);

class UpoladFile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      article: {
        title: "",
        content: "",
        createDate: new Date(),
        image: "",
        eng: "true",
      },
    };
  }

  modules = {
    keyboard: {
      bindings: {
        linebreak: {
          key: 13,
          handler: function (range, _context) {
            this.quill.clipboard.dangerouslyPasteHTML(
              range.index,
              "<p><br/><br/></p>"
            );
          },
        },
      },
    },
    toolbar: {
      container: [
        [{ header: "1" }, { header: "2" }, { font: [] }],
        [{ size: [] }],
        ["bold", "italic", "underline", "strike", "blockquote"],

        [
          { align: [] },
          { list: "ordered" },
          { list: "bullet" },
          { indent: "-1" },
        ],

        ["link", "image"],
        ["clean", "code-block"],
      ],
      handlers: {
        image: () => this.quillImageCallBack(),
      },
    },
    clipboard: {
      matchVisual: false,
    },
  };

  formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "video",
    "code-block",
  ];

  submitArticle = () => {
    const article = this.state.article;
  };

  fileCompress = (file) => {
    return new Promise((resolve, reject) => {
      new Compressor(file, {
        file: "File",
        quality: 0.8,
        maxWidth: 640,
        maxHeight: 640,
        success(file) {
          return resolve({
            success: true,
            file: file,
          });
        },
        error(err) {
          return resolve({
            success: false,
            message: err.message,
          });
        },
      });
    });
  };

  quillImageCallBack = () => {
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", ".pdf,.doc,.docx");
    input.click();

    input.onchange = async () => {
      const file = input.files[0];
      const compressState = await this.fileCompress(file);
      if (compressState.success) {
        const fileName = file.name;
        storageRef
          .ref()
          .child("Files/" + fileName)
          .put(compressState.file)
          .then(async (snapshot) => {
            const downloadURL = await storageRef
              .ref()
              .child("Files/" + fileName)
              .getDownloadURL();
            let quill = this.quill.getEditor();
            const range = quill.getSelection(true);
            quill.insertEmbed(range.index, "file", downloadURL);
          });
      }
    };
  };

  uploadImageCallBack = (e) => {
    return new Promise(async (resolve, reject) => {
      const file = e.target.files[0];
      const fileName = e.target.files[0].name;
      let downloadURL = null;
      storageRef
        .ref()
        .child("Files/" + fileName)
        .put(file)
        .then(async (snapshot) => {
          downloadURL = await storageRef
            .ref()
            .child("Files/" + fileName)
            .getDownloadURL();
          let data = {
            title: fileName,
            link: downloadURL,
          };

          await service.InsertItem(data);
          resolve({
            success: true,
            data: { link: downloadURL },
          });
          window.location.reload();
        });
    });
  };

  render() {
    return (
      <Container>
        <Row>
          <Col xl={3} lg={3} md={4} sm={12} xs={12}>
            <Card>
              <CardHeader>File Upload (.pdf/.doc/.docx)</CardHeader>
              <CardBody>
                <FormGroup>
                  <Label className={classes.Label}>File</Label>
                  <Input
                    type="file"
                    accept=".pdf,.docx,.doc"
                    className={classes.ImageUploader}
                    onChange={async (e) => {
                      const uploadState = await this.uploadImageCallBack(e);
                      if (uploadState.success) {
                        this.setState({
                          hasImage: true,
                          article: {
                            ...this.state.article,
                            image: uploadState.data.link,
                          },
                        });
                      }
                    }}
                  ></Input>
                  {this.state.hasImage ? (
                    <img
                      alt="img"
                      src={this.state.article.image}
                      className={classes.Image}
                    />
                  ) : (
                    ""
                  )}
                </FormGroup>
              </CardBody>
            </Card>
          </Col>
          <Col xl={3} lg={3} md={4} sm={12} xs={12}></Col>
        </Row>
      </Container>
    );
  }
}

export default UpoladFile;
